import React, { useRef } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { CmsEntities } from 'client/data/models/cms';
import { useOnScreenFromBottom } from 'site-modules/shared/hooks/use-on-screen-from-bottom';
import { PhotoflipperVideoImageTopRated } from 'site-modules/shared/components/editorial/photoflipper-video-image-top-rated/photoflipper-video-image-top-rated';
import { MarketingButtons } from 'site-modules/editorial/components/top-rated/marketing-buttons/marketing-buttons';
import { getStaticImageUrl } from 'client/utils/image-helpers';

export function ByTheNumbers({
  entry,
  featuredVideoImageGallery = null,
  fullImageSizeFromMetadata = null,
  marketingButtonEntry = null,
}) {
  const ref = useRef();
  const [isOnScreen, isIntersectingFromBottom] = useOnScreenFromBottom(ref, {
    root: null,
    rootMargin: '0px',
    threshold: 0.1,
  });

  const renderEntries = () => {
    const entries = entry.children();
    return entries.map(child => (
      <article
        className="data-item d-flex align-items-end ps-0 pe-0 mb-1 mb-0 justify-content-center"
        key={child.metadata('title').value()}
      >
        <div className="d-block px-1 px-lg-2_5">
          <span
            className="data-value d-inline-block size-36 mb-0_5 text-white fw-bold"
            style={{ WebkitBackgroundClip: 'text' }}
          >
            {child.metadata('content').value()}
          </span>
          <span className="data-title d-block size-16">
            <span className="text-white hidden-lg-up">{child.metadata('title').value()}</span>
            <span className="text-blue-80 hidden-lg-down">{child.metadata('title').value()}</span>
          </span>
        </div>
      </article>
    ));
  };
  return (
    <article
      key={entry.metadata('title').value()}
      className={classnames(`by-the-numbers text-center mx-auto cool-gray-100`, {
        'is-intersecting': isOnScreen,
        'is-intersecting-from-bottom': isIntersectingFromBottom,
      })}
      style={{
        maxWidth: '750px',
      }}
    >
      {featuredVideoImageGallery && (
        <figure className="video-container overflow-hidden" style={{ aspectRatio: '16/9' }}>
          <PhotoflipperVideoImageTopRated
            vehicleGallery={featuredVideoImageGallery}
            fullImageSize={fullImageSizeFromMetadata}
          />
        </figure>
      )}
      {marketingButtonEntry && <MarketingButtons entry={marketingButtonEntry} />}
      <div ref={ref} className="mx-auto d-flex justify-content-between align-items-start px-md-2_5">
        {renderEntries()}
      </div>
      <div className="pt-3_5 pt-sm-2_5 px-md-2 pb-3 header-content">
        <img
          className="mb-1"
          width={32}
          height={22}
          src={getStaticImageUrl('/img/top-rated/2026/quote-icon.svg')}
          alt=""
          aria-hidden
        />
        <p className="d-block pb-0_5">{entry.metadata('content').value()}</p>
        <p className="size-20 fw-medium mb-0 text-primary">{entry.metadata('authorName').value()}</p>
        <p className="size-14 mb-0">{entry.metadata('authorTitle').value()}</p>
      </div>
    </article>
  );
}

ByTheNumbers.propTypes = {
  entry: CmsEntities.Content.isRequired,
  featuredVideoImageGallery: PropTypes.arrayOf(PropTypes.shape({})),
  fullImageSizeFromMetadata: PropTypes.string,
  marketingButtonEntry: CmsEntities.Content,
};
